import ImageModel from "./image";
const ImageModels = {
  image: ImageModel
};
export default ImageModels;